import {dropdownNodes} from './dropdownNodes';

const settings = ({
  api: {
    url: '/api/search/tasks?query={query}',
    resultSelectorJSONata: '$.content[].{\'name\': workflowName & \' : \' & taskName, \'value\': workflowId, \'description\': input.key & \' : \' & [input.summary, \'Untitled\'][0], \'descriptionVertical\': true, \'text\': input.key, \'link\': \'/workflows/\' & workflowId}',
  },
});

export const issueNodes = view => dropdownNodes({
  view, id: 'issue', name: 'issue', text: 'Issue', settings,
});

export const issuesNodes = view => dropdownNodes({
  view, id: 'issues', name: 'issues', text: 'Issues', settings, multiple: true,
});
